var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriceBandwith(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "price-bandwith",
    clipPath: "url(#clip0_5039_377120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.00009 18.0978C5.42263 15.5942 5.42263 11.5351 8.00009 9.03147C10.5775 6.52788 14.7564 6.52788 17.3339 9.03147C19.9114 11.5351 19.9114 15.5942 17.3339 18.0978M4.88882 21.1199C0.59305 16.9472 0.59305 10.182 4.88882 6.00937C9.18458 1.83672 16.1494 1.83672 20.4452 6.00937C24.7409 10.182 24.7409 16.9472 20.4452 21.1199",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 309",
    d: "M14.667 13.001V12.9549C14.667 12.1629 13.9717 11.52 13.1136 11.52H12.2189C11.3623 11.52 10.667 12.1629 10.667 12.9549V12.9753C10.667 13.7673 11.3623 14.4102 12.2189 14.4102H13.1136C13.9717 14.4102 14.667 15.0531 14.667 15.8451C14.667 16.6372 13.9717 17.28 13.1136 17.28H12.2189C11.3623 17.28 10.667 16.6372 10.667 15.8451V15.7841",
    stroke: "#145DD7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 310",
    d: "M12.667 11.5201V10.5601",
    stroke: "#145DD7",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 311",
    d: "M12.2373 18.3679C12.2373 18.6441 12.4612 18.8679 12.7373 18.8679C13.0134 18.8679 13.2373 18.6441 13.2373 18.3679H12.2373ZM13.2373 18.3679V16.5825H12.2373V18.3679H13.2373Z",
    fill: "#145DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5039_377120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceBandwith);
export default __webpack_public_path__ + "static/media/price-bandwith.bc32b837317faf0e63732c2b8f8ff280.svg";
export { ForwardRef as ReactComponent };